import Vue from "vue"
import Router from "vue-router"
import Home from "@/views/System/Home"
import adminRouter from "./modules/backend/admin"
import adminEditRouters from "./modules/backend/adminEdit"
import systemRouter from "./modules/system"
import companyRouter from "./modules/company"
import appTemplateRouter from "@/router/modules/appTemplateCenter"
import iotRouters from "@/router/modules/iot"
import boardRouter from "@/router/modules/board"
import ruleRouter from "@/router/modules/rule"
import Layout from "@/views/layout"
import frontRouters from "./modules/front"
import adminProjectRouters from "./modules/backend/project"
import LoginRooter from "./modules/login"
import extraRouters from "./modules/extraRouters"
import appTemplate from "./modules/appTemplate"

Vue.use(Router)

const originalReplace = Router.prototype.replace

Router.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err)
}

const constantRouterMap = [
  systemRouter,
  companyRouter,
  appTemplateRouter,
  iotRouters,
  boardRouter,
  ruleRouter,
  ...adminEditRouters,
  ...LoginRooter,
  ...extraRouters,
  ...appTemplate,
  {
    path: "/",
    component: Layout,
    name: "main",
    redirect: "/home",
    children: [
      ...frontRouters,
      adminRouter,
      adminProjectRouters,
      {
        path: "/home",
        name: "home",
        component: Home
      },
      {
        path: "todo",
        component: () => import("@/views/Company/Todo"),
        name: "company-todo"
      },
      {
        path: "/upgrade",
        name: "upgrade",
        component: () => import("@/views/Upgrade")
      }
      // {
      //   path: "/userCenter",
      //   name: "userCenter",
      //   component: () => import("@/views/UserCenter.vue"),
      //   children: [
      //     {
      //       path: "file",
      //       name: "file",
      //       component: () => import("@/views/userCenter/file/index")
      //     }
      //   ]
      // }
    ]
  }
]

/**
 * 代替push, 避免重复跳转警告
 * @param location
 */
Router.prototype.goto = function(location) {
  if (typeof location === "string") {
    if (this.currentRoute?.path === location) return
  } else {
    if (this.currentRoute?.name === location?.name) return
  }
  this.push(location)
}

const router = new Router({
  mode: "history",
  routes: constantRouterMap
})

export default router
